import {
  defaultEntityState,
  IEntityState,
  INormalizedPayload,
} from '@core/state/entities/entity';
import { IInvitationSecureDetails } from '@core/state/entities/invitation-secure-details/invitation-secure-details.entity';
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import {
  entityKey,
  EntityKeys,
  InvitationSecureDetailsKey,
} from '@core/state/entities/entity-name-map';
import { ProjectChildKeys } from '@core/state/entities/project/project.entity';

export const invitationSecureDetailsReducer = createReducer(
  defaultEntityState<IInvitationSecureDetails>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.projectListingsLoaded,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.invitationGroupsBulkUpdatedSuccessfully,
    projectDetailActions.invitationsBulkResentSuccessfully,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    (state, props) =>
      mergeEntityState(entityKey.invitationSecureDetails, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);

const has: INormalizedPayload<ProjectChildKeys> = 2 as any;
const x: INormalizedPayload<InvitationSecureDetailsKey> = has;
